import { ImportCsvModal } from 'iron-forge-react-modules';
import * as types from './types';



export const propertyName2Comment: Record<types.InventoryItemsPropertyName, string> = {
  sku: 'sku',
  name: 'name',
  description: 'description',
  netSuiteInternalId: 'netSuiteInternalId',
  deviceType: 'deviceType'
};



export const propertyName2Data: Record<types.InventoryItemsPropertyName, ImportCsvModal.IFormatTypeData> = {
  sku: {
    example: "10010201",
    properFormat: "",
    fnValidate: () => true
  },
  name: {
    example: "FLI CHARGE FLIHUB+FLICUBE BUND",
    properFormat: "",
    fnValidate: () => true
  },
  description: {
    example: "FLI CHARGE FLIHUB+FLICUBE BUND-NEW,WHITE,COMPLETE",
    properFormat: "",
    fnValidate: () => true
  },
  netSuiteInternalId: {
    example: "9512",
    properFormat: "",
    fnValidate: () => true
  },
  deviceType: {
    example: "SIM",
    properFormat: "",
    fnValidate: () => true
  }
};
